import React from 'react'
import { useFormikContext } from 'formik'
import { useRouter } from 'next/router'
import { FormattedMessage } from 'react-intl'
import { Button } from '@material-ui/core'
import { SemiConfigFormValues } from './ProductsConfiguration'
import { TabsEnum } from '@src/routes/Configurators/products/TubesMTORedesign/ProductsConfiguration'
import { ActiveLinkType } from './enum'

interface NextStepButtonProps {
  nextStepAction: () => void
  disabled: boolean
}

const NextStepButtonComponent: React.FC<NextStepButtonProps> = ({
  nextStepAction,
  disabled,
}) => {
  const router = useRouter()
  const formik = useFormikContext<SemiConfigFormValues>()
  const currentActiveLink =
    router.query.activeLink || (ActiveLinkType.ProductSearch as string)
  let nextStepButtonId = 'milliplex-nextStep-button'
  let nextStepButtonTextId = 'LABEL_LAB_WATER_NEXT_STEP'
  let nextStepButtonTextMessage = 'Next Step'
  if (currentActiveLink === ActiveLinkType.ReviewOrder) {
    return <></>
  } else if (currentActiveLink === ActiveLinkType.ProductSearch) {
    //search and multiple upload comes here
    if (formik.values.activeSearchTab === TabsEnum.SequenceEntry) {
      nextStepButtonId = 'search-data'
      nextStepButtonTextId = 'SEARCH'
      nextStepButtonTextMessage = 'Search'
    } else {
      return <></>
    }
  } else if (
    currentActiveLink === ActiveLinkType.ItemSelection ||
    currentActiveLink === ActiveLinkType.Specifications
  ) {
    nextStepButtonId = 'continue'
    nextStepButtonTextId = 'CONTINUE'
    nextStepButtonTextMessage = 'Continue'
  } else {
    return <></>
  }
  return (
    <Button
      id={nextStepButtonId}
      data-testid={nextStepButtonId}
      variant="contained"
      size="medium"
      color="primary"
      onClick={nextStepAction}
      disabled={disabled}
    >
      <FormattedMessage
        id={nextStepButtonTextId}
        defaultMessage={nextStepButtonTextMessage}
      />
    </Button>
  )
}

export default NextStepButtonComponent
